import { render, staticRenderFns } from "./EventPartDialog.vue?vue&type=template&id=d8779680&"
import script from "./EventPartDialog.vue?vue&type=script&lang=js&"
export * from "./EventPartDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports